<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.warningForCreditLimit) {
    <div class="alert alert-danger">Warning credit limit for customer passed 80%.</div>
  }
  <div class='sheet'>


    <h1 class='header'>Create a new order</h1>

    <!-- check for existing orders and prompt -->

    @if (this.existingOrders.length > 0) {
      <span style="color:red;font-weight:bold">Please note existing accepted orders exist on the system for this account and site</span><br /><br />
      <table class="table">
        <thead>
          <tr>
            <th>Order Number</th>
            <th>Account</th>
            <th>Site</th>
            <th>Tip Site</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (order of this.existingOrders; track order) {
            <tr>
              <td>{{ order.id }}</td>
              <td>{{ order.account.name }}</td>
              <td>{{ order.site.name }}</td>
              <td>{{ order.tipSite.name}}</td>
              <td>{{ order.description }}</td>
              <td><button class='btn btn-warning' [routerLink]="'/orders/edit/' + order.id">View Order</button></td>
            </tr>
          }
        </tbody>
      </table>
    }

    <app-order-form [materialUplifts]='this.materialUplifts' [account]='this.account' [site]='this.site' [order]='this.order' [orderLines]='this.orderLines'></app-order-form>
    <button type="submit" class="btn btn-success" (click)='onSubmit()'>Save</button>&nbsp;
    <button type="button" class="btn btn-danger" routerLink='/orders'>Cancel</button>
  </div>
</div>
